// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
import { gql } from 'apollo-angular';

export const claGroupsForProjectListQuery = gql`
  query claGroupsForProjectListQuery(
    $organizationId: String!
    $projectId: String!
    $organizationInternalId: String
  ) {
    claGroupsForProjectList(
      organizationId: $organizationId
      projectId: $projectId
      organizationInternalId: $organizationInternalId
    ) {
      signedClaList {
        cclaUrl
        projectLogo
        projectName
        projectSfid
        projectType
        signatoryName
        signedOn
        claGroupName
        subProjects
        signatureId
        signingEntityId
        signingEntityName
      }
      unsignedProjectList {
        canSign
        claGroupId
        claGroupName
        projectName
        projectSfid
        cclaEnabled
        iclaEnabled
        subProjects
      }
    }
  }
`;
